import * as React from "react";

import {
    Grid,
    GridColumn,
    GridSelectionChangeEvent,
    getSelectedState,
} from "@progress/kendo-react-grid";
import {
    Form,
    Field,
    FormElement,
    FormRenderProps,
} from "@progress/kendo-react-form";

import { StackLayout } from "@progress/kendo-react-layout";

import { FormDatePicker} from "../FormComponents";

import { getter } from "@progress/kendo-react-common";

import { useAppSelector } from "../../store/store";
import EventSummaryGrid from "./EventSummaryGrid";
import ExternalSummaryGrid from "./ExternalSummaryGrid";
import OpenSummaryGrid from "./OpenSummaryGrid";

const allReports = [
    {
        "ID": 1,
        "Title": "Event Summary",
    },
    {
        "ID": 2,
        "Title": "External Exams",
    },
    {
        "ID": 3,
        "Title": "Open Exams",
    }
]
const DATA_ITEM_KEY = "ID";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const ReportsGrid = (props: any) => {
    const auth = useAppSelector((state) => state.auth);

    const [gridHeight, setGridHeight] = React.useState<string>("600px");

    const [selectedReport, setSelectedReport] = React.useState<string>("");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
        setGridHeight((window.innerHeight - 100) + "px");
    }, []);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const ReportForm = React.useRef<any>(null);

    const onGridSelectionChange = (event: GridSelectionChangeEvent) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);

        let [key, value] = Object.entries(newSelectedState)[0];
        if (value === true) {
            console.info("form", ReportForm.current.values);
            setSelectedReport(allReports[+key - 1].Title);
        }
    }; 

    return (
        <React.Fragment>
            {(selectedReport === "") && (
                <div>
                    <div className="sds-gridHeader">Reports</div>
                    <div
                        style={{ overflow: "auto", marginLeft: "16px" }}
                        className={"sds-bold"}
                    >
                        <Form
                           ref={ReportForm}
                           render={(formRenderProps: FormRenderProps) => (
                                <div>
                                    <div style={{ alignSelf: "center" }}>
                                        <FormElement
                                            style={{ overflow: "auto", marginTop:"-32px", marginBottom:"32px", marginLeft: "16px", marginRight: "32px" }}>
                                            <div className={"sds-questionnaire"}>
                                                <fieldset
                                                    style={{}}
                                                    className={"k-form-fieldset"}
                                                >
                                                    <StackLayout gap={24}>
                                                        <Field
                                                           label={"From Date"}
                                                           name={"fromDate"}
                                                           component={FormDatePicker}
                                                           placeholder=""
                                                           defaultValue={new Date("2025-04-01T12:00:00") }
                                                        />
                                                        <Field
                                                            label={"To Date"}
                                                            name={"toDate"}
                                                            component={FormDatePicker}
                                                            placeholder=""
                                                            defaultValue={new Date("2026-03-31T12:00:00")}
                                                       />
                                                        <div/><div/>
                                                    </StackLayout>
                                                </fieldset>
                                            </div>
                                        </FormElement>
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                   <Grid
                        style={{ height: gridHeight }}
                        className="sds-selectable"
                        data={allReports.map((item) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                        }))}
                        resizable={false}
                        reorderable={false}
                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            drag: false,
                            cell: false,
                            mode: "single",
                        }}
                        onSelectionChange={onGridSelectionChange}
                        size={"small"}
                    >
                        <GridColumn field="Title" filterable={false} />
                    </Grid></div>
           )}

            {(selectedReport === "Event Summary") && (
                <EventSummaryGrid
                    fromDate={ReportForm?.current?.values?.fromDate?.toLocaleDateString() ?? new Date("2025-04-01T12:00:00").toLocaleDateString()}
                    toDate={ReportForm?.current?.values?.toDate?.toLocaleDateString() ?? new Date("2026-03-31T12:00:00").toLocaleDateString()}
                    returnLabel="Return to Reports"
                    onReturn={() => setSelectedReport("")} />
            )}

            {(selectedReport === "External Exams") && (
                <ExternalSummaryGrid
                    fromDate={ReportForm?.current?.values?.fromDate?.toLocaleDateString() ?? new Date("2025-04-01T12:00:00").toLocaleDateString()}
                    toDate={ReportForm?.current?.values?.toDate?.toLocaleDateString() ?? new Date("2026-03-31T12:00:00").toLocaleDateString()}
                    returnLabel="Return to Reports"
                    onReturn={() => setSelectedReport("")} />
            )}

            {(selectedReport === "Open Exams") && (
                <OpenSummaryGrid
                    fromDate={ReportForm?.current?.values?.fromDate?.toLocaleDateString() ?? new Date("2025-04-01T12:00:00").toLocaleDateString()}
                    toDate={ReportForm?.current?.values?.toDate?.toLocaleDateString() ?? new Date("2026-03-31T12:00:00").toLocaleDateString()}
                    returnLabel="Return to Reports"
                    onReturn={() => setSelectedReport("")} />
            )}
        </React.Fragment>
    );
}
export default ReportsGrid;
